import { useMemo } from "react";
import { useSelector } from "react-redux";
import { moduleCan, moduleCanAtPath } from "../../permissions/crud";

// What the logged-in user may DO on one module (a page / sub-tab), read from the permissions the database gave their role — nothing is
// written here per button. A module has four permissions only — view / create / update / delete — and a button says which of them it
// performs; any other word is turned into its closest one ("import" / "duplicate" → create, "edit" → update, "view on store" → view):
//   const can = useModuleActions("all-products");   can("import")   →  true when the role holds Create on that module.
// `slug` is the last part of the module's path ("orders", "master-settings/groups"); leave it out and the module of the CURRENT page is used
// (for pages that the admin and the customer side share). A module the user does not hold gives no actions at all.
// (The same thing as <ModuleProvider> + <PermissionButton> + usePermission() in src/permissions, for pages written that way.)
export default function useModuleActions(slug) {
  const modules = useSelector((s) => s.auth.modules);
  return useMemo(
    () => (action) => (slug ? moduleCan(modules, slug, action) : moduleCanAtPath(modules, window.location.pathname, action)),
    [modules, slug],
  );
}
